module.exports = __webpack_public_path__ + "img/ckjd.26c726b4.svg";